import { LoadablePaint } from '@confluence/loadable';

export const TabsRenderer = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TabsRenderer" */ '../src/components/TabsRenderer.tsx'
			)
		).TabsRenderer,
});
